module.exports = __webpack_public_path__ + "/images/monitorizacion-precios-baby-EN.4dba49a.png";